module.exports = __webpack_public_path__ + "img/banner_2.fd7e2bff.jpg";